import { useEffect, useState } from 'react';
import CroopLoader from './CroopLoader';
import './CroopLaunch.css';

const shouldAnimateLaunch = () => {
  const standalone = window.matchMedia?.('(display-mode: standalone)').matches ||
    (window.navigator as Navigator & { standalone?: boolean }).standalone;
  return Boolean(standalone && !window.matchMedia?.('(prefers-reduced-motion: reduce)').matches);
};

// The OS splash is static. This animation runs once the installed web app mounts.
export default function CroopLaunch() {
  const [visible, setVisible] = useState(shouldAnimateLaunch);

  useEffect(() => {
    if (!visible) return;
    // Also dismiss if the browser does not deliver the CSS animation event.
    const timeout = window.setTimeout(() => setVisible(false), 1800);
    return () => window.clearTimeout(timeout);
  }, [visible]);

  if (!visible) return null;

  return (
    <button
      type="button"
      className="croop-launch"
      aria-label="Skip Croop opening animation"
      onClick={() => setVisible(false)}
      onAnimationEnd={() => setVisible(false)}
    >
      <CroopLoader size={240} className="croop-launch__logo" duration={1.6} label="" />
    </button>
  );
}
